import { createContext, useContext } from 'react';

import { ProductCardSource } from '~/src/common/components/GridCard/ProductCard/types';
import { UpdateCartProduct } from '~/src/common/hooks/cart/types';
import {
  AddToCartProductEventSource,
  ExtraCartEventProperties,
} from '~/src/common/services/Tracker';
import { noop } from '~/src/common/utils/function';

export interface ProductCardContextType {
  analyticsData: {
    categoryName?: string;
    subcategoryName?: string;
    eventSource: AddToCartProductEventSource;
    otherAnalyticsProperties?: ExtraCartEventProperties;
    source: ProductCardSource;
  };
  product: UpdateCartProduct | undefined;
  onUpdateQuantity: (quantity: number) => void;
}

export const ProductCardContext = createContext<ProductCardContextType>({
  analyticsData: {
    eventSource: 'products list',
    // Setup nécessaire pour préserver un type plus strict
    source: { type: 'products list', detail: { categoryId: 'unknown' } },
  },
  product: undefined,
  onUpdateQuantity: noop,
});

export const useProductCardContext = () => useContext(ProductCardContext);
